import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import firebasePlugin from '@/plugins/firebase.js'
import CommandPlugin from '@/plugins/Command'
import './styles/quasar.styl'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import _ from 'lodash'
import * as Ramda from 'ramda'
// eslint-disable-next-line import/no-duplicates
import VeeValidate from 'vee-validate'
import NafComponents from 'NafComponents/fields-generator/index.js'
import FieldsGenerator from 'NafComponents/fields-generator/FieldsGenerator.vue'
// eslint-disable-next-line import/no-duplicates
import { Validator } from 'vee-validate'
import InitRules from 'NafComponents/fields-generator/custom-validation-rules'
import VueRouterBackButton from 'vue-router-back-button'
import 'vue-tel-input/dist/vue-tel-input.css'
import ValidateDictionary from 'NafComponents/fields-generator/custom-validation-rules/dictionary.js'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import {
  QAvatar,
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QBadge,
  QIcon,
  QList,
  QItem,
  QImg,
  QItemSection,
  QPageScroller,
  QFooter,
  QItemLabel,
  QScrollArea,
  QPageSticky,
  QSpinnerBall,
  QCard,
  QCardSection,
  QCardActions,
  QTable,
  QTr,
  QTd,
  QMenu,
  QInput,
  QCheckbox,
  QSeparator,
  QDate,
  QPopupProxy,
  QDialog,
  Loading,
  QInnerLoading,
  QSpace,
  QTabs,
  QTab,
  QRouteTab,
  QTabPanels,
  QTabPanel,
  Notify,
  QAjaxBar,
  ClosePopup,
  QChip,
  QPullToRefresh,
  QSelect,
  QSpinner,
  GoBack,
  QInfiniteScroll,
  QSpinnerTail,
  QColor,
  QRadio,
  QExpansionItem,
  QUploader,
  QTooltip,
  QMarkupTable,
  QTree,
  QOptionGroup,
  QTh,
  QSlider,
  QRating
} from 'quasar'

Vue.use(Quasar, {
  config: {
    loading: {
      spinner: QSpinner
    },
    cordova: {
      backButtonExit: false
    }
  },
  components: {
    QAvatar,
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QPageScroller,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QBadge,
    QIcon,
    QImg,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QFooter,
    QScrollArea,
    QPageSticky,
    QSpinnerBall,
    QCard,
    QCardSection,
    QCardActions,
    QTable,
    QTr,
    QTd,
    QMenu,
    QInput,
    QCheckbox,
    QSeparator,
    QDate,
    QPopupProxy,
    QDialog,
    QInnerLoading,
    QSpace,
    QTabs,
    QTab,
    QRouteTab,
    QTabPanels,
    QTabPanel,
    QAjaxBar,
    QChip,
    QPullToRefresh,
    QSelect,
    QSpinner,
    QInfiniteScroll,
    QSpinnerTail,
    QColor,
    QRadio,
    QExpansionItem,
    QUploader,
    QTooltip,
    QMarkupTable,
    QTree,
    QOptionGroup,
    QTh,
    QSlider,
    QRating
  },
  directives: [
    ClosePopup,
    GoBack
  ],
  plugins: {
    Loading,
    Notify
  },
  framework: {
    cssAddon: true
  },
  animations: 'all'
})
Vue.use(NafComponents)
Vue.component('fields-generator', FieldsGenerator)
Vue.config.productionTip = false
Vue.use(firebasePlugin)
Vue.use(CommandPlugin)
Validator.localize(ValidateDictionary)
Vue.use(VeeValidate)
Vue.use(VueRouterBackButton, { router })
Vue.set(Vue.prototype, '_', _)
Vue.set(Vue.prototype, 'R', Ramda)
InitRules(Validator)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://f86eefb8144842428d5e807404080175@sentry.io/1515746',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}